import { Alert } from '../alert.model';
import { CompanyBasic } from './company-basic.model';


export class CompanyAlert {
  companyId: string;
  id: number;
  alert: Alert;
  company: CompanyBasic;
  addPrimary: boolean;
  addSecondary: boolean;
  repeatAlert: boolean;
  alertFrequency: string;
  indefiniteInstance: boolean;
  instanceCount: number;
}
